import { render, staticRenderFns } from "./AdminChallengeForm.vue?vue&type=template&id=c48da136&"
import script from "./AdminChallengeForm.vue?vue&type=script&lang=js&"
export * from "./AdminChallengeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports